import { render, staticRenderFns } from "./item-statistic.vue?vue&type=template&id=4c24073a&scoped=true"
import script from "./item-statistic.vue?vue&type=script&lang=js"
export * from "./item-statistic.vue?vue&type=script&lang=js"
import style0 from "./item-statistic.vue?vue&type=style&index=0&id=4c24073a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c24073a",
  null
  
)

export default component.exports